import React, { useEffect, useState } from 'react';
import Modal from '../../../components/shared/Modal/Modal';
import { getParcelEvents } from '../../../services/parcels';
import type { ParcelEvent } from '../../../types/api';

interface Props {
  parcelId: number;
  trackingCode: string;
  onClose: () => void;
}

const LABEL: Record<ParcelEvent['event_type'], string> = {
  created: 'Created', dispatched: 'Dispatched', arrived: 'Arrived',
  delivered: 'Delivered', picked: 'Picked', cancelled: 'Cancelled',
};

export const ParcelHistoryModal: React.FC<Props> = ({ parcelId, trackingCode, onClose }) => {
  const [events, setEvents] = useState<ParcelEvent[] | null>(null);

  useEffect(() => {
    let active = true;
    getParcelEvents(parcelId)
      .then((e) => { if (active) setEvents(e); })
      .catch(() => { if (active) setEvents([]); });
    return () => { active = false; };
  }, [parcelId]);

  return (
    <Modal isOpen onClose={onClose} title={`History — ${trackingCode}`} size="md">
      {events === null ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : events.length === 0 ? (
        <p className="text-sm text-slate-500">No events recorded.</p>
      ) : (
        <ol className="space-y-3">
          {events.map((e) => (
            <li key={e.id} className="flex items-start gap-3">
              <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-brand-600" />
              <div className="text-sm">
                <p className="font-medium text-slate-900">{LABEL[e.event_type] ?? e.event_type}</p>
                <p className="text-slate-500">
                  {new Date(e.created_at).toLocaleString()}
                  {e.actor_name ? ` · ${e.actor_name}` : ''}
                  {e.trip_route ? ` · ${e.trip_route}` : ''}
                </p>
              </div>
            </li>
          ))}
        </ol>
      )}
    </Modal>
  );
};
